/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { EXCLUDED_BANNERS_SITE_PASS_IDS } from 'ui-sitepass/src/constants';

export const shouldShowSitePassBanner = (
    facilityId,
    facilitiesUsingSitePassIntegration = {}
) => {
    if (!facilityId) {
        return false;
    }

    const defaultValue = !!facilitiesUsingSitePassIntegration?.default;
    const includeFacilityId =
        !!facilitiesUsingSitePassIntegration?.hasOwnProperty(facilityId);

    if (!includeFacilityId) {
        return defaultValue;
    }

    const isSitePassBannerEnabled = !!facilitiesUsingSitePassIntegration?.[facilityId];

    return isSitePassBannerEnabled;
};

export const showSitePassBanner = (
    facilityId,
    facilitiesUsingSitePassIntegration = {}
) => {
    if (EXCLUDED_BANNERS_SITE_PASS_IDS?.indexOf(facilityId) >= 0) {
        return false;
    }

    return shouldShowSitePassBanner(facilityId, facilitiesUsingSitePassIntegration);
};

export const showSitePassAlert = (
    facilityId,
    facilitiesUsingSitePassIntegration = {}
) => {
    return shouldShowSitePassBanner(facilityId, facilitiesUsingSitePassIntegration);
};

export const showNewSitePassLayout = (sitePassUiRevamp = false) => {
    return !!sitePassUiRevamp;
};
